import { Observable } from 'rxjs';
import { IdentityUser } from '../user';
import { Menu } from '../menu';

/**
 * Define el repositorio para obtener información del usuario en sesión
 */
export abstract class IdentityRepository {
  /**
   * Obtiene la información del usuario en sesión
   */
  abstract getUserInfo(): Observable<IdentityUser>;

  /**
   * Obtiene el menú del usuario en sesión
   */
  abstract getUserMenu(): Promise<Menu[]>;

  /**
   * Realiza el logout completo del usuario
   */
  abstract fullLogout(): void;

  /**
   * Limpia la sesión almacenada localmente
   */
  abstract clearLocalSession(): void;
}
